export default __webpack_public_path__ + "static/media/708.3ce1f310.png";